export enum ErrorWebXR {
  UNDEFINED = 'UNDEFINED',
  NOT_SUPPPORTED = 'NOT_SUPPPORTED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  MOTION_PERMISSION_DENIED = 'MOTION_PERMISSION_DENIED',
  CAMERA_PERMISSION_DENIED = 'CAMERA_PERMISSION_DENIED',
  MIC_PERMISSION_DENIED = 'MIC_PERMISSION_DENIED',
}